import { Navigate, Outlet } from "react-router";
import { useSetupSsoToken } from "@/auth";
import { userCache } from "@/shared-utils";

export function AdminRoutes() {
    useSetupSsoToken();
    return userCache.containsGroup("HQDOMAIN_Mgmt-US-N-ExWoQueueMgmt") ? <Outlet /> : <Navigate to="/" />;
}
